<template>
    <div class="components-reservation-form">
        <a id="form" href="#form" class="smooth-anchor smooth-scroll"></a>
        <div class="columns">

            <div class="column is-12 is-offset-0 is-10-widescreen is-offset-1-widescreen is-8-fullhd is-offset-2-fullhd">
                <div class="box components-reservation-form__box has-background-white-bis has-text-centered" v-if="step === 1">
                    <div class="columns has-text-left">
                        <div class="column">
                            <div class="field">
                                <label class="label" :class="'has-text-' + secondaryColor" >{{ $t('reservation.date') }}</label>
                                <div class="control has-icons-left">
                                    <div class="select reservation-form__select">
                                        <datepicker
                                            input-class="input"
                                            :disabled-dates="passDisabledDates"
                                            maximum-view="day"
                                            v-model="dateValue"
                                            :language="language"
                                            :monday-first="true"
                                        ></datepicker>
                                    </div>
                                    <span class="icon is-small is-left">
                                      <i class="fas fa-calendar-alt"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label class="label" :class="'has-text-' + secondaryColor">{{ $t('reservation.time') }}</label>
                                <div class="control has-icons-left">
                                    <div class="select reservation-form__select">
                                        <select name="time" v-model="timeValue">
                                            <option v-for="option in timeOptions" :value="option">{{ option }}</option>
                                        </select>
                                    </div>
                                    <span class="icon is-small is-left">
                                      <i class="fas fa-clock"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label class="label" :class="'has-text-' + secondaryColor">{{ $t('reservation.persons') }}</label>
                                <div class="control has-icons-left">
                                    <div class="select reservation-form__select">
                                        <select name="num" v-model="numValue">
                                            <option v-for="num in parseInt(maxPersons)" :value="num" v-if="num > 1">{{ num }}</option>
                                        </select>
                                    </div>
                                    <span class="icon is-small is-left">
                                      <i class="fas fa-users"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a class="reservation-form__button button is-success" @click="nextStep">{{ $t('reservation.continue') }}</a>
                </div>

                <div class="box components-reservation-form__box has-background-white-bis has-text-centered" v-if="step === 2">
                    <div class="columns">
                        <div class="column">
                            <p v-html="reservationText"></p>
                        </div>
                    </div>
                    <div class="columns has-text-left">
                        <div class="column">
                            <div class="field">
                                <label class="label" :class="'has-text-' + secondaryColor">{{ $t('reservation.name') }}</label>
                                <div class="control has-icons-left">
                                    <input
                                        :class="{'is-danger': nameError}"
                                        class="input" type="text" name="name" v-model="nameValue"/>
                                    <span class="icon is-small is-left">
                                      <i class="fas fa-user"></i>
                                    </span>
                                </div>
                                <p class="help is-danger" v-if="nameError">{{ nameError }}</p>
                                <p class="help" v-else>{{ $t('reservation.name-hint') }}</p>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label class="label" :class="'has-text-' + secondaryColor">E-mail</label>
                                <div class="control has-icons-left">
                                    <input
                                        :class="{'is-danger': emailError}"
                                        class="input" type="text" name="email" v-model="emailValue"/>
                                    <span class="icon is-small is-left">
                                      <i class="fas fa-at"></i>
                                    </span>
                                </div>
                                <p class="help is-danger" v-if="emailError">{{ emailError }}</p>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label class="label" :class="'has-text-' + secondaryColor">{{ $t('reservation.phone') }}</label>
                                <div class="control has-icons-left">
                                    <input
                                        :class="{'is-danger': phoneError}"
                                        class="input" type="text" name="phone" v-model="phoneValue"/>
                                    <span class="icon is-small is-left">
                                      <i class="fas fa-phone"></i>
                                    </span>
                                </div>
                                <p class="help is-danger" v-if="phoneError">{{ phoneError }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="columns has-text-left">
                        <div class="column">
                            <div class="field">
                                <label class="label" :class="'has-text-' + secondaryColor">{{ $t('reservation.note') }}</label>
                                <div class="control has-icons-left">
                                    <input class="input" type="text" name="note" v-model="noteValue"/>
                                    <span class="icon is-small is-left">
                                      <i class="fas fa-pen"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column has-text-right has-text-centered-mobile">
                            <a class="reservation-form__button button is-info" @click="goBack">{{ $t('reservation.back') }}</a>
                        </div>
                        <div class="column has-text-left has-text-centered-mobile">
                            <a
                                class="reservation-form__button button is-warning"
                                :class="{ 'is-loading': loading }"
                                @click="send"
                            >{{ $t('reservation.reserve') }}</a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import moment from 'moment';
    import axios from 'axios';
    import {en, cs, de, sk} from 'vuejs-datepicker/dist/locale'

    export default {
        name: "ReservationForm",
        props: {
            fromDate: String,
            toDate: String,
            fromHour: String,
            toHour: String,
            maxPersons: String,
            locale: String,
            disabledDays: Array,
            disabledDates: Array,
            createUrl: String,
            secondaryColor: String
        },
        components: {
            Datepicker
        },
        data() {
            return {
                dateValue: null,
                idealTime: 19,
                timeValue: '19:00',
                numValue: 2,
                nameValue: null,
                emailValue: null,
                phoneValue: null,
                noteValue: null,
                passDisabledDates: {
                    to: moment(this.fromDate).toDate(),
                    from: new Date(this.toDate),
                    days: this.disabledDays,
                },
                language: en,
                step: 1,
                timeOptions: [],
                loading: false,

                nameError: null,
                emailError: null,
                phoneError: null,
            }
        },
        computed: {
            reservationText() {
                return this.$tc('reservation.vue-details', this.numValue, {
                    date: moment(this.dateValue).format('D.M.Y'),
                    time: this.timeValue,
                    persons: this.numValue,
                });
            },
        },
        methods: {
            clearErrors() {
                this.nameError = null;
                this.emailError = null;
                this.phoneError = null;
            },
            nextStep() {
                this.step = 2;
                $('#form').click();
            },
            goBack() {
                if (!this.loading) {
                    this.clearErrors();
                    this.step = 1;
                    $('#form').click();
                }
            },
            send() {
                if (!this.loading) {
                    this.loading = true;
                    this.clearErrors();
                    let data = {
                        date_time: moment(this.dateValue).format('Y-MM-DD') + ' ' + this.timeValue + ':00',
                        persons: this.numValue,
                        name: this.nameValue,
                        email: this.emailValue,
                        phone: this.phoneValue,
                        note: this.noteValue,
                    };

                    axios.post(this.createUrl, data).then((response) => {
                        window.location.href = response.data.url;
                        this.loading = false;
                    }).catch((error) => {
                        let errors = error.response.data.errors;
                        this.nameError = errors.name ? errors.name[0] : null;
                        this.emailError = errors.email ? errors.email[0] : null;
                        this.phoneError = errors.phone ? errors.phone[0] : null;
                        this.loading = false;
                    });
                }
            },
        },
        mounted() {
            this.dateValue = moment(this.fromDate).toDate();
            this.passDisabledDates.dates = this.disabledDates.map(function(date){
                return new Date(date);
            });

            if (this.fromHour > this.toHour) {
                this.fromHour = this.toHour;
            }

            if (this.toHour < this.idealTime) {
                this.idealTime = this.toHour - 2;
            }

            if (this.fromHour > this.idealTime) {
                this.idealTime = this.fromHour;
            }

            this.timeValue = this.idealTime + ':00';

            for (let i = this.fromHour; i <= this.toHour; i++) {
                this.timeOptions.push(i + ':00');
                if (i < this.toHour) {
                    this.timeOptions.push(i + ':30');
                }
            }

            switch(this.locale) {
                case 'cs': this.language = cs; break;
                case 'en': this.language = en; break;
                case 'sk': this.language = sk; break;
                case 'de': this.language = de; break;
            }
        }
    }
</script>

<style lang="sass">
    .reservation-form__select
        width: 100%
        cursor: pointer
        & input
            cursor: pointer
        & select
            width: 100%
            border-width: 1px
    .reservation-form__button
        width: 10rem
</style>
